import { Component, OnInit } from '@angular/core';

import { AddAppoinmentsComponent } from '../add-appoinments/add-appoinments.component';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AppoinmentserviceService } from '../add-appoinments/appoinmentservice.service';
import { ServiceService } from '../service.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogContentExample2Component } from '../dialog-content-example2/dialog-content-example2.component';
import { DialogContentExample3cancelComponent } from '../dialog-content-example3cancel/dialog-content-example3cancel.component';
import { ArRescheduleComponent } from './ar-reschedule/ar-reschedule.component';

@Component({
  selector: 'app-appoinments',
  templateUrl: './appoinments.component.html',
  styleUrls: ['./appoinments.component.scss']
})
export class AppoinmentsComponent implements OnInit {
  apptmts: any = [];
  patientid = [{}];
  searchDoctor: string = '';
  constructor(private service: ServiceService, public dialog: MatDialog,private router: Router) {
  }

  ngOnInit(): void {
    this.get()
  }

  edit(id:number){
    this.router.navigate(['/base/patient/edit-appoinment/' + id ]);
  }


  get() {
    this.service.Get_Appointmentall()
      .subscribe(data => {
        console.log('appoin view' , data)
        this.apptmts = data
      })
  }
  view(d: any) {
    const dialogRef = this.dialog.open(DialogContentExample2Component,
      {
        height: '85%',
        width: '65%',
        data: { d }
      });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 2000);
    });
  }

  reschedule(d: any) {
    const dialogRef = this.dialog.open(ArRescheduleComponent, {
      width: "100%",
      maxWidth: "400px",
      height: "auto",
      hasBackdrop: true,
      maxHeight: "700px",
      data: { d }
    });


    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      setTimeout(() => {
        // window.location.reload();
      }, 2000);
    });
  }

  delete(d: any) {
    const dialogRef = this.dialog.open(DialogContentExample3cancelComponent, {
      width: "100%",
      maxWidth: "400px",
      height: "auto",
      hasBackdrop: true,
      maxHeight: "700px",
      data: { d }
    });


    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      setTimeout(() => {
        // window.location.reload();
      }, 2000);
    });
  }

  applySearch() {
    const searchValue = this.searchDoctor.toLowerCase().trim();
    if (!searchValue) {
      // If search input is empty, reset the data
      this.get();
      return;
    }

    // Filter appointments based on doctor's name
    this.apptmts = this.apptmts.filter(apptmt => {
      return (
        apptmt.appt_DO_Name.toLowerCase().includes(searchValue)
      );
    });
  }

  // delete(d:any) {
  //   const dialogRef = this.dialog.open(DeleteCountryComponent,
  //     {
  //       width: "100%",
  //         maxWidth: "400px",
  //         height: "auto",
  //         hasBackdrop: true,
  //         maxHeight: "700px",
  //       data: {d}
  //     });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(`Dialog result: ${result}`);
  //     setTimeout(() => {
  //       window.location.reload();
  //   }, 2000);

  //   });
  // }
}

